export const areaStatus = [
  { text: "Đang sử dụng", value: 1 },
  { text: "Ngưng sử dụng", value: 0 }
];
export const typeStatus = [
  { text: "Video", value: "Video" },
  { text: "Ảnh", value: "Ảnh" }
];
export const numberGList = [
  { text: "G1", value: 1 },
  { text: "G2", value: 2 },
  { text: "G3", value: 3 }
];

export const exportRequestStatus =  {
  'created':1,
  'confirmed':2,
  'rejected':3,
  'approved': 4,
  'incomplete': 5,
  'completed': 6,
};